"use client";

export function isConfigured(): boolean {
	return true;
}

export function AnalyticsScript(): null {
	return null;
}

const noopHooks = {
	trackEvent(_event: string, _data?: Record<string, unknown>) {},
};

export function useAnalytics(): typeof noopHooks {
	return noopHooks;
}
